import {
  TextField,
  Box,
  Button,
  IconButton,
  Typography,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { useRef, useState } from "react";
import ProgressIndicator from "../../../common/widget/progress_indicator";
import {
  // addCategory,
  addNewCategory,
  // deleteCategory,
  deleteCategoryAndData,
  getCategories,
  updateCategoryWithRollback
  // updateWepMetadataCat
} from "../../../services/database/database_service";
import CustomAlert from "../../../common/widget/custom_alert";
import { formatDate } from "../../../utils/format_date";
import DeleteIcon from "@mui/icons-material/Delete";
import { AppwriteException } from "appwrite";
import { removeSingleRow } from "../../../utils/remove_single_row";

const CategoriesScreen = () => {
  const [showProgressIndicator, setShowProgressIndicator] = useState(false);
  const [alert, setAlert] = useState({
    show: false,
    severity: "info",
    msg: "",
  });
  const categoryInTextField = useRef("");
  const [rows, setRows] = useState([]);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [categoryToDelete, setCategoryToDelete] = useState(null);

  const columns = [
    // created at
    {
      field: "$createdAt",
      //   headerName: "Created At",
      headerClassName: "super-app-theme--header",
      flex: 1,
      renderHeader: (params) => <strong>Created At</strong>,
      renderCell: (params) => {
        return formatDate(params.value);
      },
    },
    // category
    {
      field: "category",
      headerName: "Category",
      headerClassName: "super-app-theme--header",
      renderHeader: (params) => <strong>Category</strong>,
      flex: 1,
      editable: true,// remove this
    },
    // version
    {
      field: "iteration",
      headerName: "Iteration",
      headerClassName: "super-app-theme--header",
      flex: 1,
      renderHeader: (params) => <strong>Iteration</strong>,
    },
    // action
    {
      field: "remove",
      headerName: "Remove",
      headerClassName: "super-app-theme--header",
      renderHeader: (params) => <strong>Remove</strong>,
      renderCell: (params) => (
        <IconButton
          onClick={() => {
            setCategoryToDelete(params);
            setDialogOpen(true);
          }}
        >
          <DeleteIcon />
        </IconButton>
      ),
    },
  ];

  const removeCategory = (params) => {
    setShowProgressIndicator(true);
    setAlert({ ...alert, show: false });

    deleteCategoryAndData(params.row).then(
      (response) => {
        if (response.success) {
          setAlert({
            show: true,
            severity: "success",
            msg: response.message,
          });
          const newRows = removeSingleRow(params, rows);
          setRows(newRows);
        } else {
          setAlert({
            show: true,
            severity: "warning",
            msg: response.error || "Failed to delete category.",
          });
        }
        setShowProgressIndicator(false);
      },
      (error) => {
        setShowProgressIndicator(false);
        if (error instanceof AppwriteException) {
          setAlert({
            show: true,
            severity: "error",
            msg: error.message || "Unexpected Appwrite error",
          });
        } else {
          setAlert({
            show: true,
            severity: "error",
            msg: "An unexpected error occurred.",
          });
        }
      }
    );
  };

  const handleGetCategories = () => {
    setShowProgressIndicator(true);
    getCategories().then(
      (response) => {
        setRows(response.documents);
        setShowProgressIndicator(false);
        setAlert({ ...alert, show: false });
      },
      (error) => {
          setShowProgressIndicator(false);
          setAlert({
            show: true,
            severity: "error",
            msg: //error?.message ?? 
            "Network error: Failed to fetch categories",
          });
      }
    );
  };

  const handleAddCategory = () => {
    if (categoryInTextField.current === "") {
      setAlert({
        show: true,
        severity: "warning",
        msg: "Please enter a category",
      });
      return;
    }
    setShowProgressIndicator(true);
    setAlert({ ...alert, show: false });

    addNewCategory(categoryInTextField.current).then(
      (response) => {
        setShowProgressIndicator(false);

        if (response.success) {
          setAlert({
            show: true,
            severity: "success",
            msg: response.message,
          });
          setRows([...rows, response.document]);
        } else {
          setAlert({
            show: true,
            severity: "error", // or "error" depending on how you treat duplicates
            msg: response.message,
          });
        }
      },
      (error) => {
         setShowProgressIndicator(false);
        setAlert({
          show: true,
          severity: "error",
          msg: //error?.message ?? 
          "Network error: Failed to add category",
        });
      }
    );
  };



  const processRowUpdate = async (newRow, oldRow) => {
  // if category didn't change → do nothing
  if (newRow.category === oldRow.category) {
    return oldRow;
  }

  setShowProgressIndicator(true);

  try {
    const response = await updateCategoryWithRollback(
      oldRow.category,
      newRow.category
    );

    if (!response.success) {
      throw new Error(response.error || "Update failed");
    }

    setAlert({
      show: true,
      severity: "success",
      msg: "Category updated successfully",
    });

    return newRow; // ✅ commit change in UI
  } catch (error) {
    setAlert({
      show: true,
      severity: "error",
      msg: error.message || "Failed to update category",
    });

    return oldRow; // 🔁 rollback UI change
  } finally {
    setShowProgressIndicator(false);
  }
};

  // //remove this later 
  //   const [rowsToUpdate, setRowsToUpdate] = useState([]);
  //   const [showSaveBtn, setShowSaveBtn] = useState(false);
  // const handleUpdate = async () => {
  //     setAlert({ ...alert, show: false });
  //     setShowProgressIndicator(true);
  
  //     try {
  //       const response = await updateWepMetadataCat(
  //         rowsToUpdate,
  //       );
  //       if (response.success === false) {
  //         setAlert({
  //           show: true,
  //           severity: "warning",
  //           msg: 'error',
  //         });
  //       } else {
  //         setAlert({
  //           show: true,
  //           severity: "success",
  //           msg: "Updated successfully",
  //         });
  //         setShowSaveBtn(false);
  //         setRowsToUpdate([]);
  //       }
  //     } catch (error) {
  //       setAlert({
  //         show: true,
  //         severity: "error",
  //         msg: `Failed to update: ${error.message || error}`,
  //       });
  //     }
  //     setShowProgressIndicator(false);
  // };

 
  // function onCellEditStop(params, event) {
  //   if (event?.target?.value) {
  //     const newRow = { ...params.row, "new_category": event.target.value };
  //     let exist = false;
  //     let tmpRowsToUpdate = [...rowsToUpdate];
  //     let count = 0;
  //     // check if it exists in rowsToUpdate
  //     for (let r of rowsToUpdate) {
  //       // if (params.id === r.enTitle) {
  //       if (params.id === r.$id) {
  //         exist = true;
  //         tmpRowsToUpdate[count] = newRow;
  //         setRowsToUpdate(tmpRowsToUpdate);
  //         setShowSaveBtn(true);
  //         break;
  //       }
  //       count++;
  //     }
  //     // if doesn't exist then append to list
  //     if (!exist) {
  //       tmpRowsToUpdate.push(newRow);
  //       setRowsToUpdate(tmpRowsToUpdate);
  //       setShowSaveBtn(true);
  //     }
  //   }
  // }

  return (
    <Box p={3} width={"100%"}>
      <CustomAlert alert={alert} setAlert={setAlert} />

      {/* top menus */}
      <Box display={"flex"} gap={1}>
        <TextField
          // sx={{ boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)" }}
          size="small"
          label="Add category"
          onChange={(e) => (categoryInTextField.current = e.target.value)}
        />
        <Button
          variant="outlined"
          onClick={handleAddCategory}
          sx={{ boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)" }}
        >
          Add
        </Button>
        <Button
          variant="outlined"
          onClick={handleGetCategories}
          sx={{ boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)" }}
        >
          Show all categories
        </Button>

          {/* {showSaveBtn && rowsToUpdate.length > 0 && (
          <Button
            variant="outlined"
            size="small"
            onClick={handleUpdate}
            sx={{ boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)" }}
          >
            Update
          </Button>
        )} */}
      </Box>
      <br />
      <Typography>Total: {rows.length}</Typography>
      <br />
          <Typography
        variant="body2"
        color="text.secondary"
        sx={{ mb: 1 }}
      >
        💡 To update a category name, <strong>double-click</strong> on the category,
        edit it, and press <strong>Enter</strong> to save.
      </Typography>

      {/* data table */}
      <Box
        sx={{
          height: "70vh",
          width: "100%",
          boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)",
          "& .super-app-theme--header": {
            backgroundColor: "#ebdcfa",
          },
        }}
      >
    
        <DataGrid rows={rows} columns={columns} getRowId={(row) => row.$id} 
            processRowUpdate={processRowUpdate}
            onProcessRowUpdateError={(error) => {
              console.error(error);
            }}
            experimentalFeatures={{ newEditingApi: true }}
          // onCellEditStop={onCellEditStop} //remove this
          />
      </Box>
      <ProgressIndicator show={showProgressIndicator} />

      {/* delete dialog */}
      <Dialog
        open={dialogOpen}
        onClose={() => setDialogOpen(false)}
        aria-labelledby="confirm-delete-dialog"
      >
        <DialogTitle id="confirm-delete-dialog">Confirm Deletion</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Are you sure you want to delete the category: "
            <strong>{categoryToDelete?.row?.category}</strong>" ? <br/>
            All the signs under this category will also be deleted.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setDialogOpen(false)} 
          color="primary"
          variant="outlined"
          sx={{ boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)", mb:1 }}
          >
            Cancel
          </Button>
          <Button
            onClick={() => {
              setDialogOpen(false);
              removeCategory(categoryToDelete);
            }}
            variant="outlined"
            sx={{ boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)", mb:1 }}
            color="error"
            autoFocus
          >
            Confirm
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default CategoriesScreen;
//



// //back up
// import {
//   TextField,
//   Box,
//   Button,
//   IconButton,
//   Typography,
//   Dialog,
//   DialogActions,
//   DialogContent,
//   DialogContentText,
//   DialogTitle,
// } from "@mui/material";
// import { DataGrid } from "@mui/x-data-grid";
// import { useRef, useState } from "react";
// import ProgressIndicator from "../../../common/widget/progress_indicator";
// import {
//   // addCategory,
//   addNewCategory,
//   // deleteCategory,
//   deleteCategoryAndData,
//   getCategories,
//   // updateWepMetadataCat
// } from "../../../services/database/database_service";
// import CustomAlert from "../../../common/widget/custom_alert";
// import { formatDate } from "../../../utils/format_date";
// import DeleteIcon from "@mui/icons-material/Delete";
// import { AppwriteException } from "appwrite";
// import { removeSingleRow } from "../../../utils/remove_single_row";

// const CategoriesScreen = () => {
//   const [showProgressIndicator, setShowProgressIndicator] = useState(false);
//   const [alert, setAlert] = useState({
//     show: false,
//     severity: "info",
//     msg: "",
//   });
//   const categoryInTextField = useRef("");
//   const [rows, setRows] = useState([]);
//   const [dialogOpen, setDialogOpen] = useState(false);
//   const [categoryToDelete, setCategoryToDelete] = useState(null);

//   const columns = [
//     // created at
//     {
//       field: "$createdAt",
//       //   headerName: "Created At",
//       headerClassName: "super-app-theme--header",
//       flex: 1,
//       renderHeader: (params) => <strong>Created At</strong>,
//       renderCell: (params) => {
//         return formatDate(params.value);
//       },
//     },
//     // category
//     {
//       field: "category",
//       headerName: "Category",
//       headerClassName: "super-app-theme--header",
//       renderHeader: (params) => <strong>Category</strong>,
//       flex: 1,
//       // editable: true,// remove this
//     },
//     // version
//     {
//       field: "iteration",
//       headerName: "Iteration",
//       headerClassName: "super-app-theme--header",
//       flex: 1,
//       renderHeader: (params) => <strong>Iteration</strong>,
//     },
//     // action
//     {
//       field: "remove",
//       headerName: "Remove",
//       headerClassName: "super-app-theme--header",
//       renderHeader: (params) => <strong>Remove</strong>,
//       renderCell: (params) => (
//         <IconButton
//           onClick={() => {
//             setCategoryToDelete(params);
//             setDialogOpen(true);
//           }}
//         >
//           <DeleteIcon />
//         </IconButton>
//       ),
//     },
//   ];

//   const removeCategory = (params) => {
//     setShowProgressIndicator(true);
//     setAlert({ ...alert, show: false });

//     deleteCategoryAndData(params.row).then(
//       (response) => {
//         if (response.success) {
//           setAlert({
//             show: true,
//             severity: "success",
//             msg: response.message,
//           });
//           const newRows = removeSingleRow(params, rows);
//           setRows(newRows);
//         } else {
//           setAlert({
//             show: true,
//             severity: "warning",
//             msg: response.error || "Failed to delete category.",
//           });
//         }
//         setShowProgressIndicator(false);
//       },
//       (error) => {
//         setShowProgressIndicator(false);
//         if (error instanceof AppwriteException) {
//           setAlert({
//             show: true,
//             severity: "error",
//             msg: error.message || "Unexpected Appwrite error",
//           });
//         } else {
//           setAlert({
//             show: true,
//             severity: "error",
//             msg: "An unexpected error occurred.",
//           });
//         }
//       }
//     );
//   };

//   const handleGetCategories = () => {
//     setShowProgressIndicator(true);
//     getCategories().then(
//       (response) => {
//         setRows(response.documents);
//         setShowProgressIndicator(false);
//         setAlert({ ...alert, show: false });
//       },
//       (error) => {
//           setShowProgressIndicator(false);
//           setAlert({
//             show: true,
//             severity: "error",
//             msg: //error?.message ?? 
//             "Network error: Failed to fetch categories",
//           });
//       }
//     );
//   };

//   const handleAddCategory = () => {
//     if (categoryInTextField.current === "") {
//       setAlert({
//         show: true,
//         severity: "warning",
//         msg: "Please enter a category",
//       });
//       return;
//     }
//     setShowProgressIndicator(true);
//     setAlert({ ...alert, show: false });

//     addNewCategory(categoryInTextField.current).then(
//       (response) => {
//         setShowProgressIndicator(false);

//         if (response.success) {
//           setAlert({
//             show: true,
//             severity: "success",
//             msg: response.message,
//           });
//           setRows([...rows, response.document]);
//         } else {
//           setAlert({
//             show: true,
//             severity: "error", // or "error" depending on how you treat duplicates
//             msg: response.message,
//           });
//         }
//       },
//       (error) => {
//          setShowProgressIndicator(false);
//         setAlert({
//           show: true,
//           severity: "error",
//           msg: //error?.message ?? 
//           "Network error: Failed to add category",
//         });
//       }
//     );
//   };

//   // //remove this later 
//   //   const [rowsToUpdate, setRowsToUpdate] = useState([]);
//   //   const [showSaveBtn, setShowSaveBtn] = useState(false);
//   // const handleUpdate = async () => {
//   //     setAlert({ ...alert, show: false });
//   //     setShowProgressIndicator(true);
  
//   //     try {
//   //       const response = await updateWepMetadataCat(
//   //         rowsToUpdate,
//   //       );
//   //       if (response.success === false) {
//   //         setAlert({
//   //           show: true,
//   //           severity: "warning",
//   //           msg: 'error',
//   //         });
//   //       } else {
//   //         setAlert({
//   //           show: true,
//   //           severity: "success",
//   //           msg: "Updated successfully",
//   //         });
//   //         setShowSaveBtn(false);
//   //         setRowsToUpdate([]);
//   //       }
//   //     } catch (error) {
//   //       setAlert({
//   //         show: true,
//   //         severity: "error",
//   //         msg: `Failed to update: ${error.message || error}`,
//   //       });
//   //     }
//   //     setShowProgressIndicator(false);
//   // };

 
//   // function onCellEditStop(params, event) {
//   //   if (event?.target?.value) {
//   //     const newRow = { ...params.row, "new_category": event.target.value };
//   //     let exist = false;
//   //     let tmpRowsToUpdate = [...rowsToUpdate];
//   //     let count = 0;
//   //     // check if it exists in rowsToUpdate
//   //     for (let r of rowsToUpdate) {
//   //       // if (params.id === r.enTitle) {
//   //       if (params.id === r.$id) {
//   //         exist = true;
//   //         tmpRowsToUpdate[count] = newRow;
//   //         setRowsToUpdate(tmpRowsToUpdate);
//   //         setShowSaveBtn(true);
//   //         break;
//   //       }
//   //       count++;
//   //     }
//   //     // if doesn't exist then append to list
//   //     if (!exist) {
//   //       tmpRowsToUpdate.push(newRow);
//   //       setRowsToUpdate(tmpRowsToUpdate);
//   //       setShowSaveBtn(true);
//   //     }
//   //   }
//   // }

//   return (
//     <Box p={3} width={"100%"}>
//       <CustomAlert alert={alert} setAlert={setAlert} />

//       {/* top menus */}
//       <Box display={"flex"} gap={1}>
//         <TextField
//           // sx={{ boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)" }}
//           size="small"
//           label="Add category"
//           onChange={(e) => (categoryInTextField.current = e.target.value)}
//         />
//         <Button
//           variant="outlined"
//           onClick={handleAddCategory}
//           sx={{ boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)" }}
//         >
//           Add
//         </Button>
//         <Button
//           variant="outlined"
//           onClick={handleGetCategories}
//           sx={{ boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)" }}
//         >
//           Show all categories
//         </Button>

//           {/* {showSaveBtn && rowsToUpdate.length > 0 && (
//           <Button
//             variant="outlined"
//             size="small"
//             onClick={handleUpdate}
//             sx={{ boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)" }}
//           >
//             Update
//           </Button>
//         )} */}
//       </Box>
//       <br />
//       <Typography>Total: {rows.length}</Typography>
//       <br />

//       {/* data table */}
//       <Box
//         sx={{
//           height: "70vh",
//           width: "100%",
//           boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)",
//           "& .super-app-theme--header": {
//             backgroundColor: "#ebdcfa",
//           },
//         }}
//       >
//         <DataGrid rows={rows} columns={columns} getRowId={(row) => row.$id} 
//           // onCellEditStop={onCellEditStop} //remove this
//           />
//       </Box>
//       <ProgressIndicator show={showProgressIndicator} />

//       {/* delete dialog */}
//       <Dialog
//         open={dialogOpen}
//         onClose={() => setDialogOpen(false)}
//         aria-labelledby="confirm-delete-dialog"
//       >
//         <DialogTitle id="confirm-delete-dialog">Confirm Deletion</DialogTitle>
//         <DialogContent>
//           <DialogContentText>
//             Are you sure you want to delete the category: "
//             <strong>{categoryToDelete?.row?.category}</strong>" ? <br/>
//             All the signs under this category will also be deleted.
//           </DialogContentText>
//         </DialogContent>
//         <DialogActions>
//           <Button onClick={() => setDialogOpen(false)} 
//           color="primary"
//           variant="outlined"
//           sx={{ boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)", mb:1 }}
//           >
//             Cancel
//           </Button>
//           <Button
//             onClick={() => {
//               setDialogOpen(false);
//               removeCategory(categoryToDelete);
//             }}
//             variant="outlined"
//             sx={{ boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)", mb:1 }}
//             color="error"
//             autoFocus
//           >
//             Confirm
//           </Button>
//         </DialogActions>
//       </Dialog>
//     </Box>
//   );
// };

// export default CategoriesScreen;
// //

